import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';

/**
 * useSignupsOpen — reads config/app.acceptingSignups, the safety switch
 * that pauses NEW sign-ups (shows the waitlist instead of a hard wall).
 * Walter 2026-06-02.
 *
 * FAIL-OPEN: a missing doc, an undefined field, or any read error is
 * treated as "open" (true). Only an explicit `acceptingSignups === false`
 * closes sign-ups — so a config glitch can never accidentally lock people
 * out. The doc doesn't need to exist for normal operation; you only
 * create/flip it when you actually want to pause.
 */
export default function useSignupsOpen() {
  const [open, setOpen] = useState(true);
  useEffect(() => {
    let unsub;
    try {
      unsub = onSnapshot(
        doc(db, 'config', 'app'),
        (snap) => {
          const v = snap.exists() ? snap.data()?.acceptingSignups : undefined;
          setOpen(v === false ? false : true);
        },
        () => setOpen(true), // permission/read error → fail open
      );
    } catch {
      setOpen(true);
    }
    return () => { try { unsub && unsub(); } catch { /* ignore */ } };
  }, []);
  return open;
}
